import { render, staticRenderFns } from "./thematicChart.vue?vue&type=template&id=3209b254&"
import script from "./thematicChart.vue?vue&type=script&lang=js&"
export * from "./thematicChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports